var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-338.000000, -523.000000)","fill":"#231F20","fillRule":"nonzero"},React.createElement("g",{"transform":"translate(157.000000, 231.000000)"},React.createElement("g",{"transform":"translate(2.000000, 284.500000)"},React.createElement("polygon",{"points":"194.45 8 202.5 12 194.45 16 194.45 12.5714286 179.5 12.5714286 179.5 11.4285714 194.45 11.4285714"}))))));
}

Arrow.defaultProps = {"viewBox":"0 0 24 9","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
